var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.92829C0 1.66377 1.02335 0.638672 2.28571 0.638672H29.7143C30.9767 0.638672 32 1.66377 32 2.92829V20.1004C32 21.3649 30.9767 22.39 29.7143 22.39H2.28571C1.02335 22.39 0 21.3649 0 20.1004V2.92829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7143 1.21108H2.28571C1.33894 1.21108 0.571429 1.9799 0.571429 2.92829V20.1004C0.571429 21.0488 1.33894 21.8176 2.28571 21.8176H29.7143C30.6611 21.8176 31.4286 21.0488 31.4286 20.1004V2.92829C31.4286 1.9799 30.6611 1.21108 29.7143 1.21108ZM2.28571 0.638672C1.02335 0.638672 0 1.66377 0 2.92829V20.1004C0 21.3649 1.02335 22.39 2.28571 22.39H29.7143C30.9767 22.39 32 21.3649 32 20.1004V2.92829C32 1.66377 30.9767 0.638672 29.7143 0.638672H2.28571Z",
    fill: "#F3F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9297 16.396H13.2188V6.35547H18.9297V16.396Z",
    fill: "#FF5F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5845 11.3737C13.5845 9.33692 14.5594 7.52262 16.0774 6.35341C14.9673 5.49843 13.5663 4.98812 12.0437 4.98812C8.43905 4.98812 5.51709 7.84699 5.51709 11.3737C5.51709 14.9004 8.43905 17.7593 12.0437 17.7593C13.5663 17.7593 14.9673 17.249 16.0774 16.394C14.5594 15.2248 13.5845 13.4105 13.5845 11.3737Z",
    fill: "#EB001B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.632 11.3737C26.632 14.9004 23.7101 17.7593 20.1054 17.7593C18.5828 17.7593 17.1818 17.249 16.0713 16.394C17.5897 15.2248 18.5646 13.4105 18.5646 11.3737C18.5646 9.33692 17.5897 7.52262 16.0713 6.35341C17.1818 5.49843 18.5828 4.98812 20.1054 4.98812C23.7101 4.98812 26.632 7.84699 26.632 11.3737Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.040a832ca0ca5f31acd558ab769a77f3.svg";
export { ForwardRef as ReactComponent };